import AddIcon from "@mui/icons-material/Add";
import { Box, Menu, MenuItem } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import Text from "../../../../../../../../components/Text";
import { StyleAddButton } from "../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import StyledButtonV2 from "../../../../../../../../components/app/StyledButtonV2";
import useSelectedPatient from "../../../../../../../../hooks/local-storage/use-selected-patient";

interface PrescriptionsPopUpProps {
  onOptionClick: (v: string) => void;
  buttonType?: "button" | "rxButton";
  variant?: "outlined" | "contained";
  title?: string;
}

export const PrescriptionsPopUp = ({
  onOptionClick,
  buttonType = "button",
  variant = "contained",
  title = "Add Prescription",
}: PrescriptionsPopUpProps) => {
  const [selectedPatient] = useSelectedPatient();
  const isPatientAvail = selectedPatient?.patientScriptsureId;

  return (
    <PopupState variant="popover" popupId="create-navbar-button-menu">
      {(menuList) => (
        <>
          <Box
            {...bindTrigger(menuList)}
            sx={{
              borderRadius: 1,
              bgcolor: "white",
              cursor: "pointer",
            }}
          >
            {buttonType === "rxButton" ? (
              <StyleAddButton
                label={title}
                variant={variant}
                onClick={() => {}}
              />
            ) : buttonType === "button" ? (
              <StyledButtonV2
                label={title}
                variant={variant}
                sIcon={<AddIcon />}
              />
            ) : null}
          </Box>
          <Menu {...bindMenu(menuList)}>
            {CREATE_TASK_LIST?.filter(
              (opt) => isPatientAvail || opt.value !== "eletronic_prescription"
            )?.map((it) => (
              <MenuItem
                onClick={() => {
                  onOptionClick(it.value);
                  menuList.close();
                }}
              >
                <Text>{it.label}</Text>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};

const CREATE_TASK_LIST = [
  { value: "paper_prescription", label: "Paper Prescription" },
  { value: "eletronic_prescription", label: "E Prescription" },
];
